import { translate } from "../i18n/index.js";
/**
 * نصّ الخطأ كما يقرؤه المستخدم — **الطريق الوحيد**.
 *
 * وسببُ وجوده أن `t(error.messageKey)` تبدو صحيحة وهي ناقصة: تُسقط السياق،
 * فرسالةٌ مثل «الملف {sizeMb} ميجا» تصل بالأقواس حرفياً. والنقص لا يظهر إلا
 * في الرسائل التي لها فراغات — أي في أسوأ لحظة، حين يكون المستخدم واقفاً
 * أمام فشل.
 *
 * فلا تُمرَّر المفاتيح إلى `t` مباشرةً: قاعدة lint تمنع ذلك، وهذه الدالة هي
 * البديل الوحيد.
 */
export function errorMessage(locale, error) {
    return translate(locale, error.messageKey, messageParams(error.context));
}
/**
 * السياق يصل من السلك `unknown` — ويُقبل منه ما يُعرض للبشر فقط.
 *
 * فكائنٌ أو مصفوفة تصل إلى الشاشة `[object Object]`، وهو نصٌّ لا يقوله أحد
 * لأحد. وما لا يصلح للعرض يُترك فراغه ظاهراً بدل أن يُملأ بقمامة.
 */
function messageParams(context) {
    if (!context)
        return undefined;
    const params = {};
    for (const [key, value] of Object.entries(context)) {
        if (typeof value === "string" || typeof value === "number")
            params[key] = value;
    }
    return params;
}
//# sourceMappingURL=text.js.map